import React from 'react';
import { Link } from 'react-router-dom';
import { usePublicCopy } from '@/i18n/publicCopy';
import { SAHI_ORB } from './PublicHeader';

const Col = ({ title, children }) => (
  <div>
    <p className="text-[11px] uppercase tracking-[0.18em] mb-3" style={{ color: 'var(--text-secondary)' }}>{title}</p>
    <ul className="space-y-2 text-sm">{children}</ul>
  </div>
);
const L = ({ to, children, testId }) => (
  <li><Link to={to} className="hover:underline" style={{ color: 'var(--text-primary)' }} data-testid={testId}>{children}</Link></li>
);

/** Footer for the public pages: crisis bar first, then About/Contact/Help, Resources (secondary destinations) and Legal. */
export function PublicFooter() {
  const { c } = usePublicCopy();
  const f = c.footer;
  return (
    <footer className="border-t px-5 md:px-8 py-10" style={{ borderColor: 'var(--border)' }} role="contentinfo" data-testid="public-footer">
      <div className="max-w-6xl mx-auto space-y-8">
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs" data-testid="footer-crisis-resources" role="complementary" aria-label={f.crisis}>
          <span style={{ color: 'var(--text-secondary)' }}>{f.crisis}:</span>
          <a href="tel:911" className="font-semibold hover:underline" style={{ color: '#A34A3E' }}>911 {f.emergency}</a>
          <a href="tel:988" className="font-semibold hover:underline" style={{ color: 'var(--accent)' }}>988 {f.lifeline}</a>
          <a href="sms:741741?body=HOME" className="font-semibold hover:underline" style={{ color: 'var(--accent-secondary)' }}>{f.text}</a>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3"><img src={SAHI_ORB} alt="" className="w-6 h-6 rounded-full" aria-hidden="true" /><span className="font-heading text-base" style={{ color: 'var(--text-primary)' }}>Sahiri Amali</span></div>
            <p className="text-xs leading-relaxed" style={{ color: 'var(--text-secondary)' }}>{f.scope}</p>
            <p className="text-xs italic mt-2" style={{ color: 'var(--text-secondary)' }}>{f.tagline}</p>
          </div>
          <Col title={f.about}>
            <L to="/about" testId="footer-about-link">{f.about}</L>
            <L to="/contact" testId="footer-contact-link">{f.contact}</L>
            <L to="/trust-safety" testId="footer-help-link">{f.help}</L>
          </Col>
          <Col title={f.resources}>
            <L to="/clips" testId="footer-clips-link">{f.clips}</L>
            <L to="/blog" testId="footer-blog-link">{f.blog}</L>
            <L to="/practitioners" testId="footer-practitioners-link">{f.practitioners}</L>
            <L to="/for-providers" testId="footer-providers-link">{f.providers}</L>
            <L to="/for-press" testId="footer-press-link">{f.press}</L>
            <L to="/for-investors" testId="footer-investors-link">{f.investors}</L>
            <L to="/vs/betterhelp" testId="footer-compare-link">{f.compare}</L>
          </Col>
          <Col title={f.legal}>
            <L to="/legal" testId="footer-terms-link">{f.terms}</L>
            <L to="/privacy" testId="footer-privacy-link">{f.privacy}</L>
            <L to="/security" testId="footer-security-link">{f.security}</L>
            <L to="/trust-safety" testId="footer-trust-link">{f.trust}</L>
            <L to="/values" testId="footer-values-link">{f.values}</L>
          </Col>
        </div>
      </div>
    </footer>
  );
}
